import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PaymentFailure: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, userType } = useAuth();

  const empresaId = searchParams.get('empresaId');
  const preferenceId = searchParams.get('preference_id');

  React.useEffect(() => {
    if (!isAuthenticated || userType !== 'Empresa') {
      navigate('/login');
    }
  }, [isAuthenticated, userType, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
        <div className="text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Pagamento Não Aprovado</h1>
          <p className="text-gray-600 mb-6">
            Seu pagamento não foi aprovado. Você pode tentar novamente ou entrar em contato com o suporte.
          </p>
          
          {preferenceId && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
              <p className="text-sm text-gray-500 mb-1">ID da Transação:</p>
              <p className="text-xs font-mono text-gray-700 break-all">{preferenceId}</p>
            </div>
          )}

          <div className="space-y-3">
            <button
              onClick={() => navigate('/empresa')}
              className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
            >
              Voltar ao Dashboard
            </button>
            {empresaId && (
              <button
                onClick={() => navigate('/mensalidades')}
                className="w-full px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
              >
                Tentar Novamente
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;


